import React, {useEffect, useState} from 'react';
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {
    Login,
    TopPage,
    Camera,
    ManualInput,
    History,
    List,
    Detail,
    TermOfService,
    UserRegister,
    UserRegisterTemporaryComplete,
    UserRegisterComplete,
    PasswordMail,
    PasswordMailComplete,
    PasswordRegenerate,
    PasswordRegenerateComplete,
    SleepCalendar,
    SleepInput
} from '../screens';

// Protected Route wrapper component
const ProtectedRoute = ({ isLogin, children }) => {
    return isLogin ? children : <Navigate to="/login" replace />;
};

// Auth Route wrapper component (redirect to /top if already logged in)
const AuthRoute = ({ isLogin, children }) => {
    return isLogin ? <Navigate to="/top" replace /> : children;
};

const MyRouter = props => {
    const isLogin = useSelector(state => state.login.isLogin);

    return (
        <>
            <Router basename={process.env.PUBLIC_URL}>
                <Routes>
                    <Route path='/' element={
                        <AuthRoute isLogin={isLogin}>
                            <Login />
                        </AuthRoute>
                    } />
                    <Route path='/login' element={
                        <AuthRoute isLogin={isLogin}>
                            <Login />
                        </AuthRoute>
                    } />
                    <Route path='/top' element={<TopPage />} />
                    <Route path='/top/:arg1' element={<TopPage />} />
                    <Route path='/camera' element={<Camera />} />
                    <Route path='/manual' element={<ManualInput />} />
                    <Route path='/manual/:reportId' element={<ManualInput />} />
                    <Route path='/manual_with_photo/:photoId/:tmpOutputValue' element={<ManualInput />} />
                    <Route path='/term_of_service' element={<TermOfService />} />
                    <Route path='/user_register' element={<UserRegister />} />
                    <Route path='/user_register_complete' element={<UserRegisterComplete />} />
                    <Route path='/user_register_temporary_complete' element={<UserRegisterTemporaryComplete />} />
                    <Route path='/history' element={<History />} />
                    <Route path='/password_regenerate/index' element={<PasswordMail />} />
                    <Route path='/password_regenerate/mail_complete' element={<PasswordMailComplete />} />
                    <Route path='/password_regenerate/input/:email/:argToken/' element={<PasswordRegenerate />} />
                    <Route path='/password_regenerate/complete' element={<PasswordRegenerateComplete />} />
                    <Route path='/sleep' element={<SleepCalendar />} />
                    <Route path='/sleep/:date' element={<SleepInput />} />
                </Routes>
            </Router>
        </>
    )
}

export default MyRouter;
